export const stopEventPropagation = (handler) => (e) => {
    e.stopPropagation();
    handler();
};
